import { isLocal } from '@/constants/server-runtime-flags';
import { useUpdateSharedState } from '@/hooks/state/shared-state';
import { buildUrlWithParams } from '@/utils/url-params';
import { signOut } from 'next-auth/react';
import { usePathname, useSearchParams } from 'next/navigation';

type UseAuth = {
  signIn: (returnUrl?: string) => Promise<void>;
  signOut: (returnUrl?: string | null) => Promise<void>;
  signUp: () => Promise<void>;
};

export const useAuth = (): UseAuth => {
  const path = usePathname();
  const searchParams = useSearchParams();
  const { mutateAsync: updateSharedState } = useUpdateSharedState();
  const fullPathWithParams = buildUrlWithParams(path, Object.fromEntries(searchParams.entries()));

  return {
    signIn: async (returnUrl?: string): Promise<void> => {
      const targetReturnUrl = returnUrl ?? fullPathWithParams;
      if (isLocal) {
        window.history.replaceState(null, '', targetReturnUrl);
        await updateSharedState({ isAuthenticated: true });
      } else {
        window.location.assign(buildUrlWithParams('/Membership/SignIn', { returnUrl: targetReturnUrl }));
      }
    },
    signOut: async (returnUrl?: string | null): Promise<void> => {
      if (isLocal) {
        await updateSharedState({ isAuthenticated: false });
      } else {
        await signOut({ redirect: true, redirectTo: `/Membership/SignOut?returnUrl=${encodeURIComponent(returnUrl || '/')}&next=true` });
      }
    },
    signUp: async (): Promise<void> => {
      if (isLocal) {
        await updateSharedState({ isAuthenticated: true });
      } else {
        window.location.assign(`/Membership/Register?returnUrl=${path}`);
      }
    },
  };
};
